import { Component, ViewChild, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from 'src/app/models/administration/user-management/user';
import { AsyncDropdown } from 'src/app/models/async-dropdown';
import { DropdownData } from 'src/app/models/dropdownData';
import { DataComponent } from 'src/app/user/order/data/data.component';

@Component({
  selector: 'apc-create-order',
  templateUrl: './create-order.component.html',
  styleUrls: ['./create-order.component.scss']
})
export class CreateOrderComponent  {
  public data: User = new User();
  public companyRoles: DropdownData[];
  public createOrderEvent: EventEmitter<boolean> = new EventEmitter();

  public role: AsyncDropdown[] = [];
  public roleLoading: boolean = false;
  @ViewChild(DataComponent, { static: false }) dataComponent: DataComponent;

  constructor(
    private modalService: NgbModal
  ) { }

  open(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  close() {
    this.modalService.dismissAll();
  }

  createOrder() {
    this.createOrderEvent.emit(true);
  }
}
